import React from 'react';
import Link from '@mui/material/Link';
import { workshopNames } from '../WorkshopLink';
import { dealUrl } from '../../utils/externalLinks';

// Opportunity name as a new-tab link to the deal page (plan 2217); plain text without an oppid.
export default function DealLink({ oppid, name }) {
  const href = dealUrl(oppid);
  if (!href) return <>{name ?? '—'}</>;
  return (
    <Link href={href} target="_blank" rel="noopener noreferrer" underline="hover"
          onClick={(e) => e.stopPropagation()}>
      {name || oppid}
    </Link>
  );
}

export const workshopCountText = (workshops) => {
  const n = (workshops || []).length;
  return `${n} workshop${n === 1 ? '' : 's'}`;
};

// Columns of an influenced deal list: "N workshops" instead of one line per workshop, the name opens the deal page.
export const dealNameColumn = (base) => ({ ...base, opensDeal: true, renderCell: (v, row) => <DealLink oppid={row.oppid} name={v} /> });
export const workshopCountColumn = (base) => ({
  ...base, label: 'Workshops', width: 100, noWrap: true, renderCell: undefined, format: workshopCountText, exportFormat: workshopNames,
  sortValue: (w) => (w || []).length,
  tooltip: 'How many workshops and events credit this deal. Open the opportunity to see them.',
});
